(function($) {
    //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
    var MQL = 1170;

    //primary navigation slide-in effect
    // if($(window).width() > MQL) {
    //  var headerHeight = $('.cd-header').height();
    //  $(window).on('scroll',
    //  {
    //         previousTop: 0
    //     }, 
    //     function () {
    //      var currentTop = $(window).scrollTop();
    //      //check if user is scrolling up
    //      if (currentTop < this.previousTop ) {
    //        //if scrolling up...
    //        if (currentTop > 0 && $('.cd-header').hasClass('is-fixed')) {
    //          $('.cd-header').addClass('is-visible');
    //        } else {
    //          $('.cd-header').removeClass('is-visible is-fixed');
    //        }
    //      } else {
    //        //if scrolling down...
    //        $('.cd-header').removeClass('is-visible');
    //        if( currentTop > headerHeight && !$('.cd-header').hasClass('is-fixed')) $('.cd-header').addClass('is-fixed');
    //      }
    //      this.previousTop = currentTop;
    //  });
    // }

    //open/close primary navigation
    $('.cd-primary-nav-trigger').on('click', function() {
        $('.cd-menu-icon').toggleClass('is-clicked');
        $('.cd-header').toggleClass('menu-is-open');

        //in firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        if ($('.cd-primary-nav').hasClass('is-visible')) {
            $('.cd-primary-nav').removeClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                $('body').removeClass('overflow-hidden');
            });
        } else {
            $('.cd-primary-nav').addClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                $('body').addClass('overflow-hidden');
            });
        }


    });



    var ig_endpoint = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=';
    var ig_token = '6059602368.97d072a.8363881ac03b42a999fbf5857214c926';
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("GET", ig_endpoint + ig_token, false); // false for synchronous request
    xmlHttp.send(null);

    try {

        var randomImages = [];
        var response = JSON.parse(xmlHttp.responseText);
        console.log(response.data);

        while (randomImages.length < response.data.length) {
            var random = response.data[Math.floor(Math.random() * response.data.length)];
            var thumb = random.images.thumbnail.url;
            var push = {
                img: thumb,
                link: random.link
            }

            var filter = randomImages.filter(function(item) {
                return item.img === push.img;
            });

            if (filter.length === 0) {
                randomImages.push(push);
            }
        }

        console.log(randomImages)

        var anchor = $('.ig-link');
        anchor.each(function(index) {
            var item = $(this);
            if (randomImages[index]) {
                item.attr('href', randomImages[index].link);
                item.href = randomImages[index].link;
                var img = item.find('img');
                img.attr('src', randomImages[index].img);
            }
        });
    } catch(err) {

    }

    // $('.indicator-filter-options').select2({
    //  theme: "classic",
    //  minimumResultsForSearch: Infinity
    // });

    $('.quote-cards-ul').masonry({
        // options
        itemSelector: '.quote-card',
    });


})(jQuery);

$(window).load(function() {
    $("#loading").delay(200).fadeOut(200);
    // $("#loading-center").click(function() {
    // $("#loading").fadeOut(500);
    // })
});

$('.image-quote-slider-wrapper').slick({
    dots: false,
    infinite: true,
    speed: 1200,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    autoplay: true,

    responsive: [{
            breakpoint: 1024,
            settings: {
              arrows: false,
            }
        },
        {
            breakpoint: 600,
            settings: {
              arrows: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
              arrows: false,
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.text-quotes').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    autoplay: true,
});


$('.hero-text-slider').slick({
    dots: true,
    infinite: true,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5500,
    speed: 400,
});

// var slider = $('.hero-text-slider');

// slider.slick({
//     autoplay: true,
//     autoplaySpeed: 1000
// }).slick("slickPause");

// var initialDelay = 3000;

// setTimeout(function() {
//     slider.slick("slickPlay");
// },initialDelay);

$('.instagram-posts-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    autoplay: true,
});

$('.quote-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
});


var logoSlider = $('.slick-logo-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    autoplay: true,
    slidesPerRow: 4,
    rows: 2,
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    // dots: false,
    // slidesToShow: 6,
    // slidesToScroll: 6,
    // autoplay: true,
    // autoplaySpeed: 0,
    // centerMode: true,
    // speed: 1000,
    // infinite: false,
    // cssEase: 'linear',
    // arrows: false,
    responsive: [{
            breakpoint: 1024,
            settings: {
                // slidesToShow: 3,
                // slidesToScroll: 3,
                slidesPerRow: 4,
                rows: 2,
                infinite: true,
                dots: false,
            }
        },
        {
            breakpoint: 600,
            settings: {
                // slidesToShow: 2,
                // slidesToScroll: 2
                slidesPerRow: 3,
                rows: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                // slidesToShow: 1,
                // slidesToScroll: 1
                slidesPerRow: 2,
                rows: 2,
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
// window.logoSlider = logoSlider;

$('.show-all-logo').on('click', function(){
    logoSlider.slick('destroy')
    $(this).hide();
})
// Select all links with hashes
// $('a[href*="#"].arrow-down')
//     // Remove links that don't actually link to anything
//     .not('[href="#"]')
//     .not('[href="#0"]')
//     .click(function(event) {
//         // On-page links
//         if (
//             location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
//             location.hostname == this.hostname
//         ) {
//             // Figure out element to scroll to
//             var target = $(this.hash);
//             target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
//             // Does a scroll target exist?
//             if (target.length) {
//                 // Only prevent default if animation is actually gonna happen
//                 event.preventDefault();
//                 $('html, body').animate({
//                     scrollTop: target.offset().top - 130
//                 }, 1000, function() {
//                     // Callback after animation
//                     // Must change focus!
//                     var $target = $(target);
//                     $target.focus();
//                     if ($target.is(":focus")) { // Checking if the target was focused
//                         return false;
//                     } else {
//                         $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
//                         $target.focus(); // Set focus again
//                     };
//                 });
//             }
//         }
//     });


//     $(window).scroll(function(){
//       var threshold = 200; // number of pixels before bottom of page that you want to start fading
//       var op = (($(document).height() - $(window).height()) - $(window).scrollTop()) / threshold;
//       if( op <= 0 ){
//         $(".arrow-down").hide();
//       } else {
//         $(".arrow-down").show();
//       }
//       $(".arrow-down").css("opacity", op ); 
//     });

//     $('.eq-animated-logo').on('scroll touchmove mousewheel', function(e){
//       e.preventDefault();
//       e.stopPropagation();
//       return false;
//     });


// $(".team-list-section ul li a").click(function() {
//     $('html,body').animate({
//         scrollTop: $(".team-list-section .tab-content").offset().top},
//         'slow');
// });